import { FC } from 'react';
export interface IInlineLoaderProps {
  variant?: 'small' | 'normal';
}
export const InlineLoader: FC<IInlineLoaderProps> = ({ variant = 'normal' }) => {
  return (
    <div className="flex items-center justify-center ">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-solid border-current border-r-transparent border-gray-500"></div>
      {variant === 'normal' && <p className="ml-4 font-comfortaa">Загрузка ...</p>}
    </div>
  );
};
